<template>
  <div class="home content-part">
    <div class="banner">
       <!-- src="http://resource.jmjnsz.com/jmjn-portal/2023/08/14/9aa3b06a-2ad1-442f-88db-6903452a1375.png" -->
      <img
        class="banner-img"
        src="http://resource.jmjnsz.com/jmjn-portal/2026/03/16/249e9932-a970-408d-95ec-cf9f228145c7.png"
        alt=""
      />
      <template v-if="locale == 'CN'">
        <div class="banner-title-cn">
          <img
            :src="require(`./../assets/images/home/banner-title.png`)"
            alt=""
          />
          <img
            @click="scrollToProd"
            class="banner-more"
            :src="require(`./../assets/images/home/banner-btn.png`)"
            alt=""
          />
        </div>
      </template>
      <template v-else>
        <div class="banner-title-en">
          <p class="title5">PROFESSIONAL COMPREHENSIVE</p>
          <p class="title5">SECONDARY ENERGY SUPPLIER</p>
          <p class="title5">STEAM, COMPRESSED AIR,</p>
          <p class="title5">CHILLED WATER, COOLING WATER, ETC.</p>
          <p class="title6">
            Continuously creating new profit centers for owners
          </p>
          <img
            @click="scrollToProd"
            class="banner-more"
            :src="require(`./../assets/images/home/banner-btn-EN.png`)"
            alt=""
          />
        </div>
      </template>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-3" v-for="(i, index) in intro" :key="index">
          <div class="left-icon">
            <img
              :src="require(`./../assets/images/home/info_${index + 1}.png`)"
              alt=""
            />
          </div>
          <div class="right">
            <div class="content">
              <div class="ctx">
                <h3 class="out">
                  {{ i.pre }}
                  <CountTo :startVal="0" :endVal="i.content" :duration="3000" />
                  {{ i.unit }}
                </h3>
                <h3 class="in">
                  {{ i.pre }}
                  <CountTo :startVal="0" :endVal="i.content" :duration="3000" />
                  {{ i.unit }}
                </h3>
              </div>
            </div>
            <p class="desc">{{ i[`desc_${locale}`] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="home-main">
      <div class="home-main-content">
        <img :src="require(`./../assets/images/home/3-${locale}.png`)" alt="" />
        <img :src="require(`./../assets/images/home/4-${locale}.png`)" alt="" />
        <img :src="require(`./../assets/images/home/5-${locale}.png`)" alt="" />
      </div>
      <div class="guide">
        <div class="left-info">
          <p class="p1">IMPLEMENTATION GUIDELINES</p>
          <p class="p2">{{ currentLg.detailTitle3 }}</p>
          <div class="line">
            <img src="./../assets/img/line.png" alt="" />
          </div>
          <img
            class="p3"
            :class="locale == 'CN' ? 'p3-cn' : 'p3-en'"
            :src="
              require(`./../assets/images/home/${
                locale == 'CN' ? '8-CN.jpg' : '8-EN.png'
              }`)
            "
            alt=""
          />
          <div class="p4"></div>
          <div class="guide-list">
            <div
              class="guide-item"
              v-for="(item, index) in guideList"
              :key="index"
              @click="changeItem(index)"
            >
              <div
                class="guide-left"
                :class="[
                  guideIndex == index ? 'guide-bg' : '',
                  locale == 'CN' ? 'guide-bg-cn' : 'guide-bg-en',
                ]"
              >
                <img
                  v-if="guideIndex == index"
                  src="./../assets/images/home/un-select-circle.png"
                  alt=""
                />
                <img
                  v-else
                  src="./../assets/images/home/selected-circle.png"
                  alt=""
                />
                {{ item[`name_${locale}`] }}
              </div>
            </div>
          </div>
        </div>
        <div class="right-imgs">
          <img
            :src="require(`./../assets/images/home/guide_${guideIndex}.jpg`)"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountTo from "vue-count-to";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import language from "./../language/home/index";
export default {
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        autoplayDisableOnInteraction: true,
        // Some Swiper option/callback...
      },
      swiperOption: {
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      projectList: [],
      newsList: [],
      bannerList: [],
      intro: [
        {
          pre: "+",
          content: 50,
          unit: "%",
          desc_CN: "信息化管理效率",
          desc_EN: "Efficiency of information management",
        },
        {
          pre: "+",
          content: 30,
          unit: "%",
          desc_CN: "建筑能源系统能效",
          desc_EN: "Energy efficiency of building energy systems",
        },
        {
          pre: "-",
          content: 30,
          unit: "%",
          desc_CN: "设备管理费用",
          desc_EN: "Costs of equipment management",
        },
      ],
      guideList: [
        {
          name_CN: "制定ESG战略、评估实质性议题",
          name_EN: "Develop ESG strategy Evaluate substantive issues",
        },
        {
          name_CN: "ESG数据收集与处理",
          name_EN: "ESG data collection and processing",
        },
        {
          name_CN: "ESG管理供应商、调动利益相关方参与",
          name_EN:
            "ESG Management Supplier  Mobilize stakeholder participation",
        },
      ],
      guideIndex: 0,
      timer: null,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },
  mounted() {
    // this.queryList();
    this.timer = setInterval(this.changeIndex, 5000);
  },
  components: {
    // 注册子组件
    swiper,
    swiperSlide,
    CountTo,
  },
  methods: {
    prevFn() {
      console.log(this.swiper);
      this.swiper.slideNext();
    },
    prevEnter() {
      // console.log(55)
      this.swiper.autoplay.stop();
      // console.log(this.swiperOptions)
    },
    prevLeave() {
      this.swiper.autoplay.start();
    },
    queryList() {
      this.$http
        .get("/api/portal/homepage/queryList")
        .then((res) => {
          this.bannerList =
            res.data && res.data.bannerList ? res.data.bannerList : [];
          this.newsList =
            res.data && res.data.newsList ? res.data.newsList : [];
          this.projectList =
            res.data && res.data.projectList ? res.data.projectList : [];
        })
        .catch((err) => {});
    },
    changeItem(index) {
      this.guideIndex = index;
    },
    scrollToProd() {
      const element = document.getElementById("home-main");
      element.scrollIntoView({ behavior: "smooth" });
    },
    changeIndex() {
      if (this.guideIndex < 2) {
        this.guideIndex++;
      } else {
        this.guideIndex = 0;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  .banner {
    // height: 78vh;
    position: relative;
    border-bottom: 4px solid;
    border-image: linear-gradient(90deg, #1289d9, #5ce282) 1;
    .banner-img {
      // height: 78vh;
    }

    .banner-title-cn {
      width: 32vw;
      position: absolute;
      right: 18vw;
      bottom: 8vw;
      .banner-more {
        cursor: pointer;
        width: 8vw;
        padding-top: 24px;
      }
    }
    .banner-title-en {
      // width: 32vw;
      position: absolute;
      color: #ffffff;
      bottom: 6vw;
      right: 6vw;
      .title5 {
        font-size: 3vw;
        font-family: SourceHanSansCN;
        font-weight: normal;
        letter-spacing: 2px;
      }
      .title6 {
        font-size: 2vw;
        font-family: SourceHanSansCN;
        font-weight: 400;
        line-height: 40px;
        margin: 45px 0;
        width: 50vw;
      }

      .banner-more {
        cursor: pointer;
        width: 8vw;
      }
    }
  }
  #home-main {
    .home-main-content {
      img {
        vertical-align: bottom;
        width: 100vw;
      }
    }
  }
}
.container {
  .row {
    display: flex;
    justify-content: center;
    .col-3 {
      width: 30%;
      padding: 60px 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content {
      .ctx {
        flex: 1;
        position: relative;
        height: 48px; /* 设置容器的高度，根据需要调整 */
        overflow: hidden;
      }
      h3 {
        font-size: 36px;
        padding-bottom: 20px;
        height: 26px;
        text-align: center;
      }
      .out {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        animation: slideUpAndDisappear 1s forwards; /* 设置动画持续时间和结束后保持最后状态 */
      }
      @keyframes slideUpAndDisappear {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(-100%);
        }
      }
      .in {
        animation-name: slideInUp;
        animation-duration: 1.5s;
        animation-timing-function: ease-out;
        animation-fill-mode: both;
      }
      @keyframes slideInUp {
        0% {
          transform: translateY(100%);
          visibility: visible;
        }
        100% {
          transform: translateY(0);
          visibility: visible;
        }
      }
    }
    .left-icon img {
      height: 90px;
      width: 90px;
      margin-right: 30px;
    }
    .left {
      flex: 1;
    }
    p {
      text-align: center;
      font-size: 18px;
    }
  }
}
.guide {
  display: flex;
  align-items: center;
  padding: 5vh;
}
.left-info {
  flex: 4;
  margin-right: 2vw;
  .p1 {
    font-size: 21px;
    font-family: SourceHanSansCN-Light, SourceHanSansCN;
    font-weight: 300;
    color: #1b263d;
    line-height: 61px;
  }
  .p2 {
    font-size: 40px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #1b263d;
  }
  .line {
    margin: 20px 0;
  }
  .p3-cn {
    width: 303px;
    height: 28px;
  }
  .p3-en {
    width: 393px;
    height: 28px;
  }
  .p4 {
    width: 450px;
    height: 2px;
    background: #1289d9;
    opacity: 1;
    border: 1px solid #1289d9;
    opacity: 0.1;
    margin: 20px 0 40px 0;
  }

  .guide-list {
    .guide-item {
      cursor: pointer;
    }
    .guide-left {
      height: 63px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      img {
        width: 13px;
        margin-right: 21px;
        margin-left: 21px;
      }
    }
    .guide-bg {
      background-image: url("./../assets/images/home/selected.png");
      background-repeat: no-repeat;
      color: #fff;
      font-size: 16px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #ffffff;
    }
    .guide-bg-cn {
      background-size: 78% 63px;
    }
    .guide-bg-en {
      background-size: 100% 63px;
    }
    @media screen and (max-width: 1280px) {
      .guide-bg-cn {
        background-size: 80% 63px;
      }
      .guide-bg-en {
        background-size: 100% 63px;
      }
    }
  }
}
.right-imgs {
  flex: 6;
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue